export const decimalToPercentage = (decimal) => {
  if (typeof decimal !== "number" || isNaN(decimal)) return "0.00%";
  return `${(decimal * 100).toFixed(2)}%`;
};

export const percentageToDecimal = (percentageStr) => {
  if (typeof percentageStr !== "string") return 0;
  const cleanedStr = percentageStr.replace("%", "").trim();
  const parsed = parseFloat(cleanedStr);
  if (isNaN(parsed)) return 0;
  return parsed / 100;
};

export const numberToText = (num) => {
  if (typeof num !== "number" || isNaN(num)) return "0.00";
  return num.toFixed(2);
};

export const numToCurrency = (value, decim = 2, curr = "$") => {
  return (
    curr +
    Number(value)
      .toFixed(decim)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  );
};

export const decimToPercent = (value, decim = 2) => {
  return Number(value * 100).toFixed(decim) + "%";
};

export const currencyToNum = (fig, dec = 2) => {
  let num = Number(parseFloat(fig.replace(/[^0-9.-]/g, "")).toFixed(dec));
  return num;
};

export const numToDecimalString = (num, dec = 2) => {
  let fig = num
    .toFixed(dec)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return fig;
};
